import React from 'react'
import { Trans } from 'react-i18next'

interface PicturesUploadTipProps {
  pictureCount: number
}

export const PicturesUploadTip: React.FC<PicturesUploadTipProps> = ({ pictureCount }) => {
  const i18nKey = `wizard.screen.multimediaNewModalContent.mobile.inlineUploadTip.imageCount.${pictureCount >= 2 ? 'reorder' : 'initial'}`

  return (
    <div
      className={'font-default-color margin-horizontal-l margin-top-l font-body-small-regular'}
      data-testid={'inline-gallery-upload-tip'}
    >
      <Trans i18nKey={i18nKey} />
    </div>
  )
}
